// Tipos de devices e a representação dos nomes no Vuetify.

// Normalmente celulares na vertical.
export const ExtraSmallScreen = "xs"; // < 600px

// Normalmente Tablets e Celulares na horizontal.
export const SmallScreen = "sm"; // 600px > < 960px

// Tablets grandes e alguns laptops.
export const MediumScreen = "md"; // 960px > < 1264px

// Laptops Grandes e Desktops
export const LargeScreen = "lg"; // 1264px > < 1904px

// 4k e ultra-wides
export const ExtraLargeScreen = "xl"; // > 1904px
